import React from 'react';
import { Permission } from '../../types/auth';
import { useAuth } from '../../context/AuthContext';

interface Props {
  required: Permission;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export default function PermissionGate({ required, children, fallback = null }: Props) {
  const { hasPermission } = useAuth();
  return hasPermission(required) ? <>{children}</> : <>{fallback}</>;
}
